module["exports"] = [
  "PT",
  "CV",
  "UD",
  "PD",
  "Perum"
];